const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',

	$domIconShow: $('.js-login-icon__eye'),
	$domIconHide: $('.js-login-icon__eye-solid'),
	classPassActive: 'pass-active',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.preventCharactersInput();
		this.showHidePassword();

		// only number allowed
		const number = $('.ginput_container_number input');
		number.keyup(function() {
			this.value = this.value.replace(/[^0-9.]/g, '');
		});
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.id;

			$(formId).parents(formHolder).addClass(sentClass);

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
			}, delay);
		}, false);
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	preventCharactersInput: () => {
		//Defining invalid characters
		const validChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Delete'];
		$('.js-prevent-character-input input').on('keydown', function(e) {
			if(!validChars.includes(e.key)) {
				//Preventing invalid characters from being entered
				e.preventDefault();
			}
		});
	},

	showHidePassword: () => {
		FormHelpers.$domIconHide.on('click', function() {
			$(this).parent().find('input').prop('type', 'text');
			$(this).parent().addClass(FormHelpers.classPassActive);
		});

		FormHelpers.$domIconShow.on('click', function() {
			$(this).parent().find('input').prop('type', 'password');
			$(this).parent().removeClass(FormHelpers.classPassActive);
		});
	}
};

export default FormHelpers;
